export const TEXT_ITEM = {
    NAME: 'Hi, My name is',
    EMAIL: 'My email address is',
    BIRTHDAY: 'My birthday is',
    LAOCATION: 'My address is',
    PHONE: 'My phone number is',
    LOGIN: 'My login is'
}

export const CARD_TEXT = {
    [TEXT_ITEM.NAME]: 'Hi, My name is',
    [TEXT_ITEM.EMAIL]: 'My email address is',
    [TEXT_ITEM.BIRTHDAY]: 'My birthday is',
    [TEXT_ITEM.LAOCATION]: 'My address is',
    [TEXT_ITEM.PHONE]: 'My phone number is',
    [TEXT_ITEM.LOGIN]: 'My login is'
}